import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "../../lib/site";
import { getLenis } from "../../lib/motion";
import { Btn } from "./Btn";

export const Logo = ({ testid = "nav-logo" }) => (
  <Link to="/" className="logo" aria-label="NovaSoft — accueil" data-testid={testid}>
    <img src="/brand/logo-full.png" width="247" height="96" alt="NovaSoft — Digital Xperience" />
  </Link>
);

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 24);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  useEffect(() => {
    const l = getLenis();
    document.body.style.overflow = open ? "hidden" : "";
    if (l) (open ? l.stop() : l.start());
    const esc = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [open]);

  return (
    <header className={`nav ${scrolled ? "is-scrolled" : ""} ${open ? "is-open" : ""}`} data-testid="site-nav">
      <div className="nav-bar">
        <Logo />
        <nav className="nav-links" aria-label="Navigation principale">
          {NAV.slice(1).map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-link-${n.to.replaceAll("/", "") || "home"}`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="nav-cta">
          <Btn to="/apercu-boutique/" variant="ghost" testid="nav-cta-apercu" className="hide-sm">Recevoir mon aperçu</Btn>
          <Btn to="/contact/" testid="nav-cta-contact" className="hide-xs">Parler de mon projet</Btn>
          <button className="burger" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="mobile-menu"
            aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} data-testid="nav-burger">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <div id="mobile-menu" className="mobile-menu" aria-hidden={!open} data-testid="mobile-menu">
        <nav aria-label="Menu mobile">
          {NAV.map((n, i) => (
            <NavLink key={n.to} to={n.to} end style={{ "--i": i }} tabIndex={open ? 0 : -1} data-testid={`mobile-link-${n.to.replaceAll("/", "") || "home"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="mobile-cta">
          <Btn to="/contact/" testid="mobile-cta-contact">Parler de mon projet</Btn>
          <Btn to="/apercu-boutique/" variant="ghost" testid="mobile-cta-apercu">Recevoir mon aperçu</Btn>
        </div>
      </div>
    </header>
  );
};
